// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as SMSUserType from "../../../app/entity/SMSUserType.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

function UserSelection(Props) {
  var customer_partner_details = Props.customer_partner_details;
  var userTypeSelection = Props.userTypeSelection;
  var dispatchUserTypeSelection = Props.dispatchUserTypeSelection;
  var getButtonClass = function (current_button) {
    if (userTypeSelection === current_button) {
      return "selected";
    } else {
      return "de-select";
    }
  };
  return React.createElement("div", {
              className: "c-user-tag-selectors"
            }, ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, tag) {
                        return React.createElement(Button$Catalyst.make, {
                                    text: SMSUserType.toString(tag),
                                    cb: (function (param) {
                                        return Curry._1(dispatchUserTypeSelection, tag);
                                      }),
                                    className: "user-tag " + getButtonClass(tag),
                                    disabled: !(tag === /* All */0 || Belt_List.has(customer_partner_details, tag, (function (userData, tagType) {
                                              return SMSUserType.fromString(userData.profile) === tagType;
                                            }))),
                                    key: String(index)
                                  });
                      }), SMSUserType.user_types)));
}

var make = UserSelection;

export {
  make ,
  
}
/* react Not a pure module */
